import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { User } from '../models/user.model';

/**
 * Takes data from a Firestore document snapshot and converts it into a
 * User object.
 *
 * @param snapshot Snapshot of the user document
 * @returns User object with the document data
 */
export function getUserFromSnapshot(
  snapshot: QueryDocumentSnapshot<DocumentData | unknown> | any
): User {
  const user = new User();
  const obj = { id: snapshot.id, ...snapshot.data() };
  Object.assign(user, obj);
  return user;
}
